module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-table-container"
  }, [(_vm.allowSearch) ? _c('div', {
    staticClass: "level is-mobile"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    on: {
      "change": _vm.setQueryColumn
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Everything")]), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return (column.searchable !== false) ? _c('option', {
      domProps: {
        "value": column.name,
        "selected": _vm.queryColumn.name === column.name
      }
    }, [_vm._v(_vm._s(column.name))]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('input', {
    staticClass: "input search-input",
    attrs: {
      "type": "text",
      "placeholder": "Type to search..."
    },
    domProps: {
      "value": _vm.query
    },
    on: {
      "input": function($event) {
        return _vm.setQuery($event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.showPagination) ? _c('paginator', {
    attrs: {
      "current_page": _vm.currentPage,
      "data_length": _vm.data.length,
      "page_length": _vm.fluidPageLength
    },
    on: {
      "set-page": _vm.setPage,
      "set-page-length": _vm.setPageLength
    }
  }) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table is-fullwidth is-hoverable is-striped data-table"
  }, [_c('thead', [_c('tr', [_vm._l((_vm.columns), function(column) {
    return (column.display !== false) ? _c('th', {
      staticClass: "data-table-header",
      on: {
        "click": function($event) {
          return _vm.applySort(column)
        }
      }
    }, [_vm._v("\n        " + _vm._s(column.name) + "\n        "), (column.sortable !== false) ? _c('span', {
      staticClass: "icon"
    }, [(_vm.sort !== column) ? _c('i', {
      staticClass: "fa fa-sort"
    }) : _vm._e(), _vm._v(" "), (_vm.sort === column && column.type === 'text' && _vm.sortDirection === 'ASC') ? _c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    }) : _vm._e(), _vm._v(" "), (_vm.sort === column && column.type === 'text' && _vm.sortDirection === 'DESC') ? _c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    }) : _vm._e(), _vm._v(" "), (_vm.sort === column && column.type === 'number' && _vm.sortDirection === 'ASC') ? _c('i', {
      staticClass: "fa fa-sort-numeric-asc"
    }) : _vm._e(), _vm._v(" "), (_vm.sort === column && column.type === 'number' && _vm.sortDirection === 'DESC') ? _c('i', {
      staticClass: "fa fa-sort-numeric-desc"
    }) : _vm._e(), _vm._v(" "), (_vm.sort === column && column.type !== 'text' && column.type !== 'number' && _vm.sortDirection === 'ASC') ? _c('i', {
      staticClass: "fa fa-sort-amount-asc"
    }) : _vm._e(), _vm._v(" "), (_vm.sort === column && column.type !== 'text' && column.type !== 'number' && _vm.sortDirection === 'DESC') ? _c('i', {
      staticClass: "fa fa-sort-amount-desc"
    }) : _vm._e()]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.$scopedSlots.controls) ? _c('th', [_vm._v("Actions")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(row, index) {
    return (index >= (_vm.fluidPageLength * (_vm.currentPage - 1)) && index < (_vm.fluidPageLength * _vm.currentPage)) ? _c('tr', [_vm._l((_vm.columns), function(column) {
      return (column.display !== false) ? _c('td', [(_vm.$scopedSlots['column_' + column.name]) ? _vm._t('column_' + column.name, null, {
        "row": row
      }) : _c('span', {
        attrs: {
          "title": _vm.getColumnData(row, column).join(' ')
        },
        domProps: {
          "innerHTML": _vm._s(_vm.getColumnDisplay(row, column))
        }
      })], 2) : _vm._e()
    }), _vm._v(" "), _vm._t("controls", null, {
      "row": row
    })], 2) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.showPagination) ? _c('paginator', {
    attrs: {
      "current_page": _vm.currentPage,
      "data_length": _vm.data.length,
      "page_length": _vm.fluidPageLength
    },
    on: {
      "set-page": _vm.setPage,
      "set-page-length": _vm.setPageLength
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level-item"
  }, [_c('strong', [_vm._v("Search by")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8769d126"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/DataTable.vue
// module id = 569
// module chunks = 0